import type { FC } from 'react';
import type { useEditor } from '@tiptap/react';
import {
  Bold, Italic, Heading1, Heading2,
  Link as LinkIcon, List, ListOrdered, Code,
} from 'lucide-react';

interface TiptapToolbarProps {
  editor: ReturnType<typeof useEditor>;
}

const TiptapToolbar: FC<TiptapToolbarProps> = ({ editor }) => {
  if (!editor) return null;

  const btn = (active: boolean) =>
    `flex h-7 w-7 items-center justify-center rounded transition-colors ${
      active
        ? 'bg-slate-200 dark:bg-slate-600 text-slate-900 dark:text-white'
        : 'text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-700'
    }`;

  return (
    <div className="flex flex-wrap gap-0.5 border-b border-slate-200 bg-slate-50 px-1.5 py-1 dark:border-slate-600 dark:bg-slate-800">
      <button type="button" className={btn(editor.isActive('bold'))} onClick={() => editor.chain().focus().toggleBold().run()}>
        <Bold className="h-3.5 w-3.5" />
      </button>
      <button type="button" className={btn(editor.isActive('italic'))} onClick={() => editor.chain().focus().toggleItalic().run()}>
        <Italic className="h-3.5 w-3.5" />
      </button>
      <button type="button" className={btn(editor.isActive('heading', { level: 1 }))} onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}>
        <Heading1 className="h-3.5 w-3.5" />
      </button>
      <button type="button" className={btn(editor.isActive('heading', { level: 2 }))} onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}>
        <Heading2 className="h-3.5 w-3.5" />
      </button>
      <button type="button" className={btn(editor.isActive('link'))} onClick={() => {
        const url = window.prompt('URL du lien');
        if (url) editor.chain().focus().setLink({ href: url }).run();
      }}>
        <LinkIcon className="h-3.5 w-3.5" />
      </button>
      <button type="button" className={btn(editor.isActive('bulletList'))} onClick={() => editor.chain().focus().toggleBulletList().run()}>
        <List className="h-3.5 w-3.5" />
      </button>
      <button type="button" className={btn(editor.isActive('orderedList'))} onClick={() => editor.chain().focus().toggleOrderedList().run()}>
        <ListOrdered className="h-3.5 w-3.5" />
      </button>
      <button type="button" className={btn(editor.isActive('codeBlock'))} onClick={() => editor.chain().focus().toggleCodeBlock().run()}>
        <Code className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};

export default TiptapToolbar;
